module.exports = __webpack_public_path__ + "img/2c.f71fd880.png";